module.exports = __webpack_public_path__ + "media/images/shapes/angles/angle-top-059b9441d2a701165f1b07d091cbbd69.svg";